import {
  selectManagerCanUseInbox,
  selectManagerCanUseVoip,
} from 'manager/selectors/manager_selectors'
import { connect } from 'react-redux'
import Referral from './components/Referral/Referral'

const mapDispatchToProps = dispatch => ({
    dispatch
})

const mapStateToProps = state => ({
  ...state.referral,
  auth: state.auth,
  referralStatus: state.referralStatus,
  canUseInbox: selectManagerCanUseInbox(state),
  canUseVoip: selectManagerCanUseVoip(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(Referral)
